<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      :header="'Alterar PAT'"
      :modal="true"
      :closable="false"
    >
      <form
        name="ChangePatForm"
        class="p-col-12"
        @submit.prevent="saveNewPat"
        style="min-height: 15vh"
      >
        <p v-if="currentPat">
          <b>Pat Atual: {{ currentPat }}</b>
        </p>
        <div class="p-fluid p-formgrid p-grid" style="min-height: 50vh">
          <div class="p-field p-col-12 p-md-9 p-mt-4">
            <AppAutocomplete
              label="Selecionar Nova Pat"
              v-model="currentPat"
              :editModel="getCurrentPatInfo"
              :fetchFunction="fetchPats"
              :optionLabel="patOptionLabel"
              fieldId="pat-select"
              :showClear="false"
              v-validate.disable="'required'"
              data-vv-name="newPat"
              :loadOnMount="true"
              :errors="errors"
              @error="handlePatFetchError"
              @change="handlePatChange"
            />
            <small
              v-if="errors.has('newPat')"
              class="p-error"
              role="alert"
            >
              PAT obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-3 p-mt-4">
            <Button
                icon="pi pi-plus"
                class="p-button-sm p-button-primary"
                @click="createPat"
                aria-label="Novo PAT"
                v-if="can('managePATs')"
                label="Adicionar PAT"
              />
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          @click="saveNewPat"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
    <PatModal
      :visible.sync="patDialog"
      :data.sync="patForm"
      @created="patCreated"
      @cancel="closeForm"
    />
  </div>
</template>

<script>
import ticketsService from "../../services/tickets.service";
import patsService from "../../services/pat.service";
import AppAutocomplete from "../elements/AppAutocomplete.vue";
import PatModal from "@/components/pats/PatModal.vue";

export default {
  name: "ChangePat",
  props: ["showToast", "show", "pat", "selected"],
  components: { AppAutocomplete, PatModal },
  data() {
    return {
      currentPat: null,
      patDialog: false,
      patForm: {},
    };
  },
  watch: {
    show() {
      if (this.show === true) {
        if (this.pat) {
          this.currentPat = this.pat
        }
      }
    },
  },
  computed: {
    patOptionLabel() {
      return (option) => {
        if (!option) return '';
        return `${option.id} | ${option.client.name || ''}`;
      };
    }
  },
  methods: {
    cancel() {
      return this.$emit("cancel");
    },
    async fetchPats(search = '') {
      try {
        let pats = await patsService.query({ 'fechado': 0, 'search': search });

        return pats;
      } catch (error) {
        console.error('Error fetching PATs:', error);
        throw error;
      }
    },
    async getCurrentPatInfo() {
      try {
        let pats = await patsService.query({ 'nopat': this.currentPat });

        if (!pats.length) {
          return null;
        }

        return pats[0];
      } catch (error) {
        console.error('Error fetching PATs:', error);
        throw error;
      }
    },
    handlePatFetchError(error) {
      console.error('Error fetching PATs:', error);
      this.$toast.add({
        severity: "error",
        summary: "Erro ao carregar PATs",
        detail: "Ocorreu um erro ao carregar a lista de PATs",
        life: 5000,
      });
    },
    handlePatChange(patId) {
      if (patId) {
        this.currentPat = patId;
      }
    },
    createPat() {
      this.patForm = {
        clientId: null,
        equipmentId: null,
      };
      this.patDialog = true;
    },
    async patCreated(pat) {
      this.currentPat = pat.id
      this.closeForm();
    },
    closeForm() {
      this.patDialog = false;
      this.patForm = {
        clientId: null,
        equipmentId: null,
      };
      return;
    },
    async saveNewPat() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        this.loading = false;
        return;
      }

      this.$validator.pause();
      this.$validator.reset();
      for (let ticket of this.selected) {
        try {
          const response = await ticketsService.changePat(ticket.id, this.currentPat);

          if (!response) {
            if (this.showToast) {
              this.$toast.add({
                severity: "error",
                summary: "Erro ao alterar a patente",
                detail: `Erro ao alterar a patente para o ticket ${ticket.id}`,
                life: 3000,
              });
            }
            this.cancel();
            return;
          }

          if (this.showToast) {
            this.$toast.add({
              severity: "success",
              summary: `Patente alterada com sucesso para o ticket ${ticket.id}`,
              detail: "",
              life: 3000,
            });
          }
        } catch (error) {
          console.error("Erro ao alterar a patente:", error);
          if (this.showToast) {
            this.$toast.add({
              severity: "error",
              summary: "Erro inesperado",
              detail: `Ocorreu um erro ao tentar alterar a patente.`,
              life: 3000,
            });
          }
        }
      }

      this.$emit("changePatOk", {
        status: "ok",
        newPat: this.currentPat,
        selected: this.selected,
      });
    }
  }
};
</script>
